import { MiniatureMessageLayout } from 'APP/main/ChatView/components/MiniatureMessageLayout/MiniatureMessageLayout';

const Location = ({
  titleClassName,
  textClassName,
  iconClassName,
  message,
  title,
  onClick,
  preventInteraction,
}) => {
  return (
    <MiniatureMessageLayout
      titleClassName={titleClassName}
      textClassName={textClassName}
      iconClassName={iconClassName}
      imageUrl={`${message.payload.url}&size=80x80`}
      title={title}
      text={message.payload.typeDescription}
      messageId={message.id}
      onClick={onClick}
      preventInteraction={preventInteraction}
    />
  );
};

export default Location;
